import { Routes, Route } from 'react-router-dom';
import { WithFeatureFlags } from '@/features/featureFlags/WithFeatureFlags';
import { Rotationsplan } from '@/domain/mitarbeiter/pages/rotationsplan';
import { Anlageassistent } from '@/domain/mitarbeiter/pages/anlageassistent';
import { DefaultPage } from '@/pages/DefaultPage';

export function Mitarbeiter() {
  return (
    <Routes>
      <Route
        path="/rotationsplan"
        element={
          <MitarbeiterRoutesWrapper>
            <WithFeatureFlags name="rotationsplan">
              <Rotationsplan />
            </WithFeatureFlags>
          </MitarbeiterRoutesWrapper>
        }
      />
      <Route
        path="/rotationsplan/:year"
        element={
          <MitarbeiterRoutesWrapper>
            <WithFeatureFlags name="rotationsplan">
              <Rotationsplan />
            </WithFeatureFlags>
          </MitarbeiterRoutesWrapper>
        }
      />
      <Route
        path="/rotationsplan/:year/:view"
        element={
          <MitarbeiterRoutesWrapper>
            <WithFeatureFlags name="rotationsplan">
              <Rotationsplan />
            </WithFeatureFlags>
          </MitarbeiterRoutesWrapper>
        }
      />
      <Route
        path="/create/*"
        element={
          <MitarbeiterRoutesWrapper hideNavigation>
            <WithFeatureFlags name="mitarbeiteranlage">
              <Anlageassistent />
            </WithFeatureFlags>
          </MitarbeiterRoutesWrapper>
        }
      />
    </Routes>
  );
}

export function MitarbeiterRoutesWrapper({
  hideNavigation = false,
  children,
}: {
  hideNavigation?: boolean;
  children: React.ReactNode;
}) {
  if (hideNavigation) {
    return <>{children}</>;
  }
  return <DefaultPage>{children}</DefaultPage>;
}
